import * as Preact from "preact"
import Frame from "@fae/source/views/components/Frame.jsx"

import "./LoadingScreen.less"

let preload = function() {}
import("@fae/source/data/preload.js").then((module) => preload = module.default)

export default function LoadingScreen() {
    return (
        <Frame>
            <div class="EmberLoadingScreen">
                <div class="ProgressBar">
                    <div class="Fill" style={{"width": (preload.loadedCount / preload.totalCount) * 100 + "%"}}/>
                </div>
            </div>
        </Frame>
    )
}
